import "./unauthorized.scss";

const Unauthorized = () => {
  return (
    <div className="unauthorized">
      <h1 className="heading">403</h1>
      <h1>Unauthorized</h1>
    </div>
  );
};

export default Unauthorized;
